<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
export default {
  components: { FontAwesomeIcon },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sortBy: 'id',
      sortDesc: true,
      totalRows: null,
      perPage: 20,
      currentPage: 1,
      fieldsTable: [
        { key: 'id', sortable: false },
        { key: 'first_name', label: this.$t('table_labels.first_name'), sortable: false },
        { key: 'last_name', label: this.$t('table_labels.last_name'), sortable: false },
        { key: 'email', label: this.$t('table_labels.email'), sortable: false },
        { key: 'mobile_phone', label: this.$t('table_labels.mobile_phone'), sortable: false },
        { key: 'phone', label: this.$t('table_labels.phone'), sortable: false },
        { key: 'birthdate', label: this.$t('table_labels.birthdate'), sortable: false },
      ],
      isBusy: false,
    };
  },
  computed: {
    sortDir() {
      return this.sortDesc ? '-' : '';
    },
  },
  mounted() {
    if(!this.isModal) {
      this.fieldsTable.push({ key: 'actions', label: this.$t('table_labels.actions'), sortable: false },);
    }
  },
};
</script>

<template>
  <b-card :border-variant="isModal ? 'white' : 'dark'"
          :header="$t('titles.contacts')"
          header-tag="header"
          :header-bg-variant="isModal ? 'white' : 'dark'"
          :header-text-variant="isModal ? 'dark' : 'white'"
          class="mb-3 w-100">
    <b-table ref="asyncTable" :items="data" stacked="md" responsive :fields="fieldsTable" :show-empty="true">
      <template v-if="!isModal" v-slot:cell(actions)="row">
        <div class="d-flex">
          <b-btn class="mr-2" size="sm" variant="outline-primary" :to="{ name: 'contacts.edit', params: { id: row.item.id } }">
            <FontAwesomeIcon :icon="['fas', 'edit']" />
          </b-btn>
          <b-btn size="sm" variant="outline-danger" @click.stop="deleteEntity(row.item.id)">
            <FontAwesomeIcon :icon="['fas', 'times-circle']" />
          </b-btn>
      </div>
      </template>
    </b-table>
  </b-card>
</template>
